const initialState = {
    data: [],
  };
  
  const grupyUReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'SET_GRUPY_U':
        return { ...state, data: action.payload };
      default:
        return state;
    }
  };
  
  export default grupyUReducer;